import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import './index.css'
import { i18nListo } from './i18n'
import App from './App.tsx'
import { firebaseAuth } from './firebase'
import { initAuth } from './services/auth'
import { instalarFetchConSesion } from './lib/fetchConSesion'
import { apiLargoUrl } from './lib/api'

// Antes que nada: toda llamada a la API lleva la sesión (el servidor lo exige).
instalarFetchConSesion(firebaseAuth, apiLargoUrl('/').replace(/\/$/, ''))

// Cargar reCAPTCHA v3 solo si esta configurado (no en dev local sin clave)
const RECAPTCHA_SITE_KEY = (import.meta as any).env?.VITE_RECAPTCHA_SITE_KEY as string | undefined;
if (RECAPTCHA_SITE_KEY && typeof document !== 'undefined') {
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(RECAPTCHA_SITE_KEY)}`;
  document.head.appendChild(s);
}

// Unregister legacy service workers (movido aqui desde inline en index.html
// para poder eliminar 'unsafe-inline' del CSP script-src).
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then(regs => regs.forEach(r => r.unregister()))
    .catch(() => {});
  caches.keys().then(keys => keys.forEach(k => caches.delete(k))).catch(() => {});
}

// Google Analytics (GA4) init — el script externo de gtag.js sigue cargado
// desde index.html. Aqui inicializamos el dataLayer pero por defecto el consentimiento
// para analiticas esta DENIED (AEPD: no instalar cookies de medicion sin opt-in).
// El CookieBanner llamara a gtag('consent', 'update', {analytics_storage: 'granted'})
// si el usuario acepta analiticas, momento en que GA empezara a enviar eventos.
declare global { interface Window { dataLayer: unknown[]; gtag: (...args: unknown[]) => void } }
window.dataLayer = window.dataLayer || [];
window.gtag = function gtag() { window.dataLayer.push(arguments); };
// Consent Mode v2: por defecto denegar analytics y marketing. Se actualiza si el usuario consiente.
window.gtag('consent', 'default', {
  analytics_storage: 'denied',
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  wait_for_update: 500,
});
window.gtag('js', new Date());
window.gtag('config', 'G-RM5Y9ENVT2', { anonymize_ip: true });

// Si el usuario ya habia consentido (carga de pagina con consent guardado), aplicar update
try {
  const raw = localStorage.getItem('funcomunion_consent');
  if (raw) {
    const c = JSON.parse(raw);
    if (c?.v === '2' && c?.analytics) {
      window.gtag('consent', 'update', { analytics_storage: 'granted' });
    }
  }
} catch {}

initAuth(firebaseAuth);

// Pintar cuando el idioma de la página esté cargado (el español va incluido;
// el resto se descarga aparte, ver src/i18n/index.ts).
i18nListo.catch(() => {}).finally(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </StrictMode>,
  )
});
